module.exports = __webpack_public_path__ + "img/19.03afcb48.png";